import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;

export const SearchHelpText = () => {
  return (
    <Wrapper>Please search for a User ID or Client ID to view summary of User Timeline.</Wrapper>
  );
};
